import { http } from 'src/config';
import { URLSVC } from 'src/config/helper/urlService';
import Swal from 'sweetalert2'
import { loadingBar } from '../globalAction';

export const setDatasetCategorys = () => {
    return (dispatch) => {
        http.get(`${URLSVC}/Admins/GetDatasetCategorys`).then((res) => {
            let data = res.data;
            if (data.IsSuccess) {
                dispatch({type: 'DATA_DATASET_CATEGORYS', payload: data.Data})
            } else {
                Swal.fire('Gagal', `${data.ReturnMessage}`, 'error')
            }
        })
    }
}

export const setDatasetCategory = (Id) => {
    return (dispatch) => {
        loadingBar(true);
        dispatch({type: 'RESET_FORM_DATASET_CATEGORY'})
        var Url = `${URLSVC}/Admins/GetDatasetCategory?Id=${Id}`;
        http.get(Url).then((res) => {
            loadingBar(false);
            let data = res.data;
            if (data.IsSuccess) {
                dispatch({ type: 'DATA_DATASET_CATEGORY', payload: data.Data })
                dispatch(setFormDatasetCategory('Id', data.Data.Id))
                dispatch(setFormDatasetCategory('Name', data.Data.Name))
                dispatch(setFormDatasetCategory('Description', data.Data.Description))
                dispatch(setFormDatasetCategory('FileLogo', data.Data.FileLogo))

                dispatch({type: 'MODAL_DATASET_CATEGORY', payload: true})
                
            } else {
                Swal.fire('Gagal', `${data.ReturnMessage}`, 'error')
            }
        })
    }
}

export const setFormDatasetCategory = (formType, formValue) => {
    return {type: 'FORM_DATASET_CATEGORY', formType, formValue}
}

export const apiAddUpdateDatasetCategory = (iData,reset) => {
    return (dispatch) => {
        loadingBar(true);
        console.log("ID NYA ",iData.Id);
        var fd = new FormData();
        var URL = ``;
        URL = `${URLSVC}/Admins/SaveDatasetCategory`;
        fd.append('Id', iData.Id);
        fd.append('Name', iData.Name);
        fd.append('Description', iData.Description);
        fd.append('FileLogoUpload', iData.FileLogo[0]);
        
        http.post(URL,fd).then((res) => {
            loadingBar(false);
            let data = res.data;
            if (data.IsSuccess) {
                Swal.fire('Berhasil', `berhasil menyimpan dataset category`, 'success');
                dispatch({ type: 'MODAL_DATASET_CATEGORY', payload: false })
                reset();
                dispatch(setDatasetCategorys())
            } else {
                dispatch({ type: 'MODAL_DATASET_CATEGORY', payload: false })
                Swal.fire('Gagal', `${data.ReturnMessage}`, 'error')
            }
        })
    }
}

export const apiDeleteDatasetCategory = (Id, Nama) => {
    return (dispatch) => {
        Swal.fire({
            title: 'Apakah anda yakin?',
            text: `Anda akan menghapus data (${Nama})!`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ya, saya yakin!'
        }).then((result) => {
            if (result.isConfirmed) {
                var fd = new FormData();
                fd.append('Id', Id);
                http.post(`${URLSVC}/Admins/DeleteDatasetCategory`,fd).then((res) => {
                    let data = res.data;
                    if (data.IsSuccess) {
                        Swal.fire('Berhasil', `Anda berhasil menghapus data (${Nama})`, 'success')
                        dispatch(setDatasetCategorys())
                    } else {
                        Swal.fire('Gagal', `${data.ReturnMessage}`, 'error')
                    }
                })
            }
        })
    }
}
